import { IGetAllGestaoDistribuicaoEpiUseCase } from "../../../presentation/useCases/read/get_all_gestao_distribuicao_epi_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGestaoEpiRepository } from "../../repositories/gestao_epi_repository";
import { GestaoDistribuicaoEpi } from "../../models/gestao_distribuicao_epi";

export class GetAllGestaoDistribuicaoEpiUseCase
  extends BasePaginatedUseCase<GestaoDistribuicaoEpi>
  implements IGetAllGestaoDistribuicaoEpiUseCase
{
  constructor(private readonly repository: IGestaoEpiRepository) {
    super();
  }

  async getAllGestaoDistribuicaoEpi(
    idsGestaoEpi: number[] | null,
    idsFuncionarios: number[] | null,
    ca: string | null,
    dataEntrega: (Date | null)[] | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const { items, totalItems, totalPages, currentPage, pageSize } =
      await this.repository.getAllGestaoDistribuicaoEpi(
        idsGestaoEpi,
        idsFuncionarios,
        ca,
        dataEntrega,
        page,
        rowsPerPage,
      );

    this._items = items;
    this._totalItems = totalItems;
    this._totalPages = totalPages;
    this._currentPage = currentPage;
    this._pageSize = pageSize;
  }
}
